export enum Milliseconds {
    ONE_SEC = 1000,
    TWO_SEC = 2000,
    FIVE_SEC = 5000,
    TWO_MIN = 120000,
    TWENTY_SEC = 20000,
    TEEN_SEC = 10000,
    RESET_CLOSE_POPUP = 200,
}
